import type { ReactNode } from 'react';
import { Col, Row } from 'react-bootstrap';
import type { FormSection } from '../schema/types';
import { renderField, type FieldRenderContext } from './renderField';

function colProps(field: { layout?: { xs?: number; md?: number } }) {
  const xs = field.layout?.xs ?? 12;
  const md = field.layout?.md ?? xs;
  return { xs, md };
}

export function renderSection(
  section: FormSection,
  context: FieldRenderContext,
): ReactNode {
  return (
    <div key={section.id} className="form-engine__section">
      {section.titleKey ? (
        <h4 className="form-engine__section-title">{context.t(section.titleKey)}</h4>
      ) : null}
      <Row className="mb-16">
        {section.fields.map((field) => (
          <Col key={field.name} {...colProps(field)} className="mb-16">
            {renderField(field, context)}
          </Col>
        ))}
      </Row>
    </div>
  );
}

export function renderSections(
  sections: FormSection[],
  context: FieldRenderContext,
): ReactNode[] {
  return sections.map((section) => renderSection(section, context));
}
